/* =====================================
   Optimized Header Script
===================================== */

(function () {
  'use strict';

  function initializeHeader() {
    /* Sticky header */

    const stickyHeader = document.getElementById('stickyHeader');

    function updateStickyHeader() {
      if (!stickyHeader) return;

      stickyHeader.classList.toggle(
        'show',
        window.scrollY > 100
      );
    }

    if (stickyHeader) {
      updateStickyHeader();

      window.addEventListener(
        'scroll',
        updateStickyHeader,
        { passive: true }
      );
    }

    /* Clone the main menu once */

    const mainNav = document.querySelector(
      'header .main-nav'
    );

    const stickyNav = document.getElementById('stickyNav');

    if (
      mainNav &&
      stickyNav &&
      !stickyNav.querySelector('.main-nav')
    ) {
      stickyNav.appendChild(mainNav.cloneNode(true));
    }

    /* Mobile menu */

    const body = document.body;
    const mobileMenu = document.getElementById('mobileMenu');
    const overlay = document.getElementById(
      'mobileMenuOverlay'
    );

    const openButton = document.getElementById(
      'openMobileMenu'
    );

    const closeButton = document.getElementById(
      'closeMobileMenu'
    );

    function openMenu() {
      if (!mobileMenu || !overlay) return;

      mobileMenu.classList.add('active');
      overlay.classList.add('active');
      body.classList.add('no-scroll');
    }

    function closeMenu() {
      mobileMenu?.classList.remove('active');
      overlay?.classList.remove('active');
      body.classList.remove('no-scroll');
    }

    openButton?.addEventListener('click', openMenu);
    closeButton?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });

    /* Mobile submenus */

    document
      .querySelectorAll('.submenu-toggle')
      .forEach(function (toggle) {
        toggle.addEventListener(
          'click',
          function (event) {
            event.stopPropagation();

            toggle.classList.toggle('open');

            toggle.nextElementSibling?.classList.toggle(
              'show'
            );
          }
        );
      });

    /* Calendly lazy loader */

    document.addEventListener('click', function (event) {
      const button = event.target.closest(
        '[data-calendly]'
      );

      if (!button) return;

      event.preventDefault();

      const url = button.dataset.calendly;

      if (!url) return;

      function openCalendly() {
        if (!window.Calendly) return;

        window.Calendly.initPopupWidget({ url: url });
      }

      if (window.Calendly) {
        openCalendly();
        return;
      }

      let script = document.querySelector(
        'script[data-calendly-widget]'
      );

      if (script) {
        script.addEventListener(
          'load',
          openCalendly,
          { once: true }
        );

        return;
      }

      script = document.createElement('script');
      script.src =
        'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.dataset.calendlyWidget = 'true';

      script.addEventListener(
        'load',
        openCalendly,
        { once: true }
      );

      document.body.appendChild(script);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeHeader,
      { once: true }
    );
  } else {
    initializeHeader();
  }
})();